import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { setIsShowLoader } from "../store/reducers/loaderReducer";
import MainService from "../helpers/services/mainService";
import { ApiService } from "../helpers/services/apiSrevice";
import SuperDetkaView from "./SuperDetkaView";
import MamaDaiView from "./MamaDaiView";
import Page404 from "./Page_404";

const CourseView = () => {

    const dispatch = useDispatch();
    const { courseId } = useParams();
    const [courseData, setCourseData] = useState(null);
    const [isUnavailable, setIsUnavailable] = useState(false);

    useEffect(() => {
        getCourseById(courseId)
    }, [courseId])

    const isUsableCourse = course => Boolean(course && course.id);

    const getCourseById = (courseId) => {
        if (!courseId) { return false };
        setIsUnavailable(false);
        setCourseData(null);
        dispatch(setIsShowLoader(true));
        MainService.callApi({
            api: ApiService.getCourseById,
            data: +courseId,
            cb: response => {
                if (response && isUsableCourse(response.data)) {
                    setCourseData(response.data);
                } else {
                    setIsUnavailable(true);
                }
            },
            getFail: () => {
                setIsUnavailable(true);
            },
            _finally: () => {
                setTimeout(() => {
                    dispatch(setIsShowLoader(false));
                }, 1000);
            }
        });
    }

    if (isUnavailable) { return <Page404 />; }

    if (!courseData) { return null; }

    return <div>
        {
            courseData.isTitleLeft ?
                <SuperDetkaView
                    courseData={courseData}
                    getCourseById={getCourseById}
                />
                :
                <MamaDaiView
                    courseData={courseData}
                    getCourseById={getCourseById}
                />
        }
    </div>

}

export default CourseView
